import React from "react";
import { PencilLine } from "lucide-react";
import {
  isFeatureSubscribed,
  getSubscription,
} from "../../../../Utils/Auth/ValidatePermissions";
import { formatDateStandard } from "smart-react";
import { GLOBAL_CONFIG } from "../../../../constants/applicationConstants";
import { retrieveAndDecrypt } from "../../../../Utils/Storage/localStorageUtil";
import { ProductButton, StatusTag } from "../Components/ProductListPrimitives";

export const ListViewItemRender = ({
  dataItem,
  subscribeButtonClick,
  isOrganizationAdmin,
  isOrganizationProduct,
  tenantID,
  subscribed,
  isButtonEnabled,
  showSubscribedLabel,
  showExpiredLabel,
  showFeatureExpirationDate,
  showButtonTitle,
  isEditFeatureButton,
}) => {
  const feature = dataItem;
  const disableFeatureMessage = retrieveAndDecrypt(
    GLOBAL_CONFIG?.FEATURE_DISABLE_MESSAGE,
  );

  const shouldRender =
    !subscribed || (subscribed && isFeatureSubscribed(feature));

  if (!shouldRender) {
    return null;
  }

  const featurePermission = getSubscription(feature?.Permissions);
  const disabled = isButtonEnabled({
    feature,
    featurePermission,
    isOrganizationProduct,
    isOrganizationAdmin,
    tenantID,
  });
  const showActionButton = !disabled;
  const disabledMessage =
    showButtonTitle({ feature }) && disabledFeatureMessage?.Value;

  return (
    <div className="-mx-2 rounded-xl px-2 transition-[background-color,transform] duration-200 ease-out hover:bg-accent/[0.12]">
      <div className="flex min-h-[56px] items-start justify-between gap-4 border-b border-border/50 py-3 last:border-b-0">
        <div className="min-w-0 flex-1 space-y-1">
          <div className="flex flex-wrap items-center gap-2 text-[14px] font-semibold text-foreground">
            <span>{feature?.display_name}</span>
            {isEditFeatureButton({ feature, featurePermission }) && (
              <button
                type="button"
                className="inline-flex h-7 w-7 items-center justify-center rounded-lg text-primary transition-colors hover:bg-primary/10"
                onClick={() => subscribeButtonClick(feature)}
                aria-label={`Edit ${feature?.display_name}`}
              >
                <PencilLine className="h-4 w-4" />
              </button>
            )}
            {showExpiredLabel({ featurePermission }) && (
              <StatusTag tone="error">Expired</StatusTag>
            )}
            {showSubscribedLabel({ feature, featurePermission }) && (
              <StatusTag tone="success">Subscribed</StatusTag>
            )}
          </div>

          {showFeatureExpirationDate({ feature, featurePermission }) && (
            <span className="block text-[13px] font-medium text-muted-foreground">
              Expiration Date:{" "}
              {formatDateStandard(featurePermission?.SubscriptionEndDate)}
            </span>
          )}

          {disabledMessage ? (
            <small className="block text-[12px] font-medium text-destructive/90">
              {disabledMessage}
            </small>
          ) : null}
        </div>

        {showActionButton ? (
          <div
            className="shrink-0 self-center"
            title={disabledMessage || undefined}
          >
            <ProductButton
              onClick={() => subscribeButtonClick(feature)}
              size="sm"
              className="min-w-[6.5rem]"
            >
              Subscribe
            </ProductButton>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ListViewItemRender;
